<template>
  <div class="userinfo-wrap">
    <p class="name">{{$t('user.profile')}}</p>
    <div class="userinfo">
      <div class="userinfo-item">
        <div class="info-list">
          <p class="label-text">{{$t('user.name')}}</p>
          <p class="info">{{show_nickname}}</p>
          <p class="change-text" @click="nameShow = !nameShow">
            <i class="el-icon-edit-outline"></i> {{$t('user.cname')}}
          </p>
        </div>
        <div class="change-box" v-show="nameShow">
          <el-form
            :model="form"
            :rules="rules"
            label-position="top"
          >
            <el-form-item :label="$t('user.newName')"  prop="name">
              <el-input type="name" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item class="last-el">
              <el-button type="primary" @click="changeNickname()" :disabled="nameDisabled">{{$t('user.confirm')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="userinfo-item">
        <div class="info-list">
          <p class="label-text">{{$t('user.email')}}</p>
          <p class="info">{{show_email}}</p>
          <p class="change-text" @click="emailShow = !emailShow">
            <i class="el-icon-edit-outline"></i>{{$t('user.cemail')}}
          </p>
        </div>
        <div class="change-box" v-show="emailShow">
          <el-form
            :model="form"
            :rules="rules"
            ref="ruleForm"
            label-position="top"
          >
            <el-form-item :label="$t('user.nemail')" prop="email">
              <div class="getcode">
                <el-input
                  type="email"
                  :placeholder="$t('user.nemail')"
                  v-model="form.email"
                ></el-input>
                <el-button type="primary" @click="sendEmail()" :disabled="emailSendDisabled">{{sendEmailSubmit}}</el-button>
              </div>
            </el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('user.code')" v-model="form.code"></el-input>
            </el-form-item>
            <el-form-item class="last-el">
              <el-button type="primary" @click="changeEmail()" :disabled="emailDisabled">{{$t('user.confirm')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="userinfo-item">
        <div class="info-list">
          <p class="label-text">{{$t('user.cPwd')}}</p>
          <p class="info">***************</p>
          <p class="change-text" @click="passwordShow = !passwordShow">
            <i class="el-icon-edit-outline"></i> {{$t('user.cPwd')}}
          </p>
        </div>
        <div class="change-box" v-show="passwordShow">
          <el-form  :model="form" ref="ruleForm" :rules="rules" label-position="top">
            <el-form-item :label="$t('user.curPwd')">
              <el-input type="password"
                :placeholder="$t('user.curPwdDesc')"
                v-model="form.oldPwd"></el-input>
            </el-form-item>
            <el-form-item :label="$t('user.newPwd')" prop="newPwd">
              <el-input type="password"
                :placeholder="$t('user.newPwdDescFirst')"
              v-model="form.newPwd"></el-input>
            </el-form-item>
            <el-form-item prop="newPwdTwo">
              <el-input type="password"
                :placeholder="$t('user.newPwdDescTwo')"
                v-model="form.newPwdTwo" ></el-input>
            </el-form-item>
            <el-form-item class="last-el">
              <el-button type="primary" @click="changePwd()" :disabled="pwdDisabled" >{{$t('user.confirm')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="userinfo-item">
        <div class="info-list">
          <p class="label-text">{{$t('user.oauth.app')}}</p>
          <div class="authorize-list">
            <dl v-for="(item,index) in authorizeList" :key="index">
              <dt>
                <i v-if="item.app == 'github'">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-github"></use>
                  </svg>
                </i>
                 <i v-if="item.app == 'facebook'">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-facebook"></use>
                  </svg>
                </i>
                 <i v-if="item.app == 'google'">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-google"></use>
                  </svg>
                </i>
                <span>{{item.account}}</span>
              </dt>
              <dd class="change-text" @click="authorizeItem(item)">{{item.authorize ?  $t('user.oauth.unAuth') : $t('user.oauth.auth')}}</dd>
            </dl>

          </div>
        </div>
      </div>
    </div>

    <div class="user-side">
      <ul>
        <li class="email-link">
          <el-tooltip class="item" effect="dark" placement="right-start">
            <div slot="content">
              <p>{{$t('user.cUs')}}</p>
              <a href="mailto:support@yisu.com">support@yisu.com</a>
            </div>
            <i class="icon el-icon-message"></i>
          </el-tooltip>
        </li>

        <li @click="advice">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('user.ask')"
            placement="right-start"
          >
            <i class="icon el-icon-chat-line-square"></i>
          </el-tooltip>
        </li>
      </ul>
    </div>

    <!-- 用户反馈 -->
    <Feedback ref="feedmodal" />

    <!-- 授权 -->
    <Authorize ref="authmodal"/>
  </div>
</template>

<script>
import Feedback from "@/components/user/Feedback";
import Authorize from "@/components/user/Authorize";
export default {
  data() {
    var validateEmail = (rule, value, callback) => {
      this.emailRule = true;
      if (value === "") {
        callback(new Error(this.$t('user.error.emailAddress')));
      } else {
        var reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/
        if (this.form.email !== "" && reg.test(value)) {
          this.emailRule = false;
          this.$refs.ruleForm.validateField("name");
        }else{
          callback(new Error(this.$t('user.error.emailFormat')));
        }
        callback();
      }
    };

    //昵称
    var validateNickname = (rule, value, callback) => {
      this.nameDisabled = true;
      if (value === "") {
        callback(new Error(this.$t('user.error.nickname')));
      } else {
        var length = value.length
        if (this.form.name !== "" && length <= 50) {
          this.nameDisabled = false;
          this.$refs.ruleForm.validateField("name");
        }else{
          callback(new Error(this.$t('user.error.nicknameFormat')));
        }
        callback();
      }
    }

      //验证密码
        var validatePwd = (rule, value, callback) => {
          this.validatePwd = false;
          if (value === "") {
            callback(new Error(this.$t('user.error.password')));
          } else {
            if (value.length < 1) {
              callback(new Error(this.$t('user.error.passwordFormat')));
            }
            if (/\d/.test(value) && /[a-z]/.test(value) && /[A-Z]/.test(value) && (value.length >= 8 && value.length <= 20)) {
              this.validatePwd = true;
            } else {
              callback(new Error(this.$t('user.error.passwordFormat')));
            }
            callback();
          }
    };

    //二次验证密码
    var validatePwdTwo = (rule, value, callback) => {
      this.validatePwdTwo = false;
      if (value === "") {
        callback(new Error(this.$t('user.error.passwordTwo')));
      } else {
        if (value.length < 1) {
          callback(new Error(this.$t('user.error.passwordFormat')));
        }
        if (value == this.form.newPwd) {
          this.validatePwdTwo = true;
        } else {
          callback(new Error(this.$t('user.error.passwordFormat')));
        }
        callback();
      }
    };

    return {
      sendEmailSubmit:this.$t('user.send'),
      nameDisabled:true,
      emailDisabled:true,
      emailSendDisabled:true,
      validatePwd:false,
      validatePwdTwo:false,
      nameShow: false,
      emailShow: false,
      passwordShow: false,
      emailRule:true,
      form: {
        email: "",
        name:'',
        code:'',
        newPwd:'',
        newPwdTwo:'',
        oldPwd:'',
      },
      rules: {
        email: [{ validator: validateEmail, trigger: ["blur",'change'] }],
        name: [{ validator: validateNickname, trigger: ["blur",'change'] }],
        newPwd: [{ validator: validatePwd, trigger: ["blur",'change'] }],
        newPwdTwo: [{ validator: validatePwdTwo, trigger: ["blur",'change'] }],
      },
      show_nickname:'',
      show_email:'',
      count:'',
      timer:'',
      authorizeList:[]
    };
  },
  watch:{
    form: {
      deep:true,
      handler(n, o) {
        this.nameDisabled = (this.form.name != '') ? false : true;
        this.emailDisabled = (this.form.email != '' && this.form.code!='') ? false : true;
      },
    },
    emailRule: {
      handler(n, o) {
        this.emailSendDisabled = ((this.form.email != '') && (this.emailRule === false)) ? false : true;
      },
    },
  },
  components: {
    Feedback,
    Authorize
  },
  methods: {
    advice() {
      this.$refs.feedmodal.showChange();
    },
    getOauthList(){
        this.$http.post('/home/user/getOauthList', {}).then((res) => {
            res = res.data.data;
            this.authorizeList = res;
        }).catch((err) => {
            this.$message.error(err)
        })
    },
    getUserInfo(){
        this.$http.post('/home/user/getUserInfo', {}).then((res) => {
            res = res.data.data;
            this.show_nickname = res.nickname;
            this.show_email = res.email;
            localStorage.setItem('inl_user_nicknname', this.show_nickname);
        }).catch((err) => {
            this.$util.handleErr(err);
        })
    },
    changeNickname(){
        if(!this.form.name){
            this.$message({
                message: 'nickname not null',
                type: 'error'
            })
            return;
        }
        this.$http.post('/home/user/editNickName', {nickName:this.form.name}).then((res) => {
            res = res.data;
            if(res.code == 0){
                localStorage.setItem('inl_user_nicknname', this.form.name);
                this.$message({
                    message: res.message,
                    type: 'success'
                })
                setTimeout(() => {
                    this.show_nickname = this.form.name;
                    this.nameShow = !this.nameShow;
                    this.form.name = '';
                    this.$router.go(0);
                }, 2000);
            }else{
                this.$message({
                    message: res.message,
                    type: 'error'
                })
            }
        }).catch((err) => {
            this.$util.handleErr(err);
        })
    },
    changeEmail(){
          if(!this.form.email){
              this.$message({
                  message: 'email not null',
                  type: 'error'
              })
              return;
          }
          if(!this.form.code){
              this.$message({
                  message: 'code not null',
                  type: 'error'
              })
              return;
          }
          this.$http.post('/home/user/editEmail', {sendEmail:this.form.email,code:this.form.code}).then((res) => {
              res = res.data;
              if(res.code == 0){
                  this.$message({
                      message: res.message,
                      type: 'success'
                  })
                  setTimeout(() => {
                      this.show_email = this.form.email;
                      this.emailShow = !this.emailShow;
                      this.form.email = '';
                      this.form.code = '';
                  }, 2000);
              }else{
                  this.$message({
                      message: res.message,
                      type: 'error'
                  })
              }
          }).catch((err) => {
              this.$util.handleErr(err);
          })
      },
    changePwd(){
          if(!this.form.newPwd){
              this.$message({
                  message: 'newPwd not null',
                  type: 'error'
              })
              return;
          }
          if(!this.form.newPwdTwo){
              this.$message({
                  message: 'newPwdTwo not null',
                  type: 'error'
              })
              return;
          }
          if(!this.form.oldPwd){
              this.$message({
                  message: 'oldPwd not null',
                  type: 'error'
              })
              return;
          }
          if(this.form.newPwdTwo != this.form.newPwd){
              this.$message({
                  message: 'The two passwords are inconsistent',
                  type: 'error'
              })
              return;
          }
          this.$http.post('/home/user/editPassWord', {oldPwd:this.form.oldPwd,newPwd:this.form.newPwd}).then((res) => {
              res = res.data;
              if(res.code == 0){
                  this.$message({
                      message: res.message,
                      type: 'success'
                  })
                  setTimeout(() => {
                      this.passwordShow = !this.passwordShow;
                      this.form.oldPwd = '';
                      this.form.newPwd = '';
                      this.form.newPwdTwo = '';
                  }, 2000);
              }else{
                  this.$message({
                      message: res.message,
                      type: 'error'
                  })
              }
          }).catch((err) => {
              this.$util.handleErr(err);
          })
      },
    sendEmail(){
        let _self = this;
          if(!this.form.email){
              this.$message({
                  message: 'email not null',
                  type: 'error'
              })
          }
          this.$http.post('/home/user/sendEmailCode', {sendEmail:this.form.email}).then((res) => {
              res = res.data;
              if(res.code == 0){
                  this.$message({
                      message: res.message,
                      type: 'success'
                  })
                const TIME_COUNT = 900
                this.count = TIME_COUNT
                this.timer = window.setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT){
                    // 倒计时时不可点击
                    this.emailRule = true
                    // 计时秒数
                    this.count--
                    // 更新按钮的文字内容
                    this.sendEmailSubmit = this.count + 's '+this.$t('user.reSend')+''
                  } else {
                    // 倒计时完，可点击
                    this.emailRule = false
                    // 更新按钮文字内容
                    this.sendEmailSubmit = this.$t('user.Send')
                    // 清空定时器!!!
                    clearInterval(this.timer)
                    this.timer = null
                  }
                }, 1000)
              }else{
                  this.$message({
                      message: res.message,
                      type: 'error'
                  })
              }
          }).catch((err) => {
              this.$util.handleErr(err);
          })
      },



      // 授权、取消授权
      authorizeItem(item){
        this.$refs.authmodal.showChange();
        this.$refs.authmodal.info = item;
      }


  },
  created() {
      this.getUserInfo();
      this.getOauthList();
  },
  computed:{
    pwdDisabled:function(){
       if(this.form.oldPwd != '' && this.validatePwd == true && this.validatePwdTwo == true){
          return false;
       }else{
         return true;
       }
    }
  },
};
</script>




<style scoped lang="scss">
.name {
  font-size: 24px;
  font-weight: 500;
  color: #0f1e33;
  line-height: 24px;
  margin-bottom: 57px;
}
.userinfo-item {
  padding-bottom: 50px;
  .info-list {
    display: flex;
    font-size: 14px;
    font-weight: 500;
    color: #2d3037;
    line-height: 14px;
    margin-bottom: 25px;
    .label-text {
      width: 130px;
      color: #5e6d81;
      font-weight: 400;
    }
    .info {
      width: 300px;
    }
    .change-text {
      color: #3377ff;
      cursor: pointer;
      i {
        color: #3377ff;
        font-weight: bold;
        margin-right: 12px;
      }
    }
  }
  .change-box {
    width: 688px;
    padding: 32px 24px;
    background: #f5f7fa;
  }
}

.getcode {
  display: flex;
  justify-content: space-between;
  .el-input {
    width: 70%;
  }
  button {
    min-width: 180px;
    background: #ebf1ff;
    color: #3377ff;
    font-size: 16px;
    border: 1px solid #ebf1ff;
  }
}

.last-el {
  margin-bottom: 0px;
  button {
    width: 100%;
    height: 48px;
    background: #ebf1ff;
    border: 1px solid #ebf1ff;
    color: #3377ff;
    font-size: 16px;
  }
}

.user-side {
  position: fixed;
  right: 20px;
  bottom: 120px;
  z-index: 10;
  ul {
    li {
      width: 48px;
      height: 48px;
      background: #f7f9ff;
      border-radius: 50%;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
      &:first-child {
        margin-bottom: 32px;
      }
      .icon {
        font-size: 24px;
        line-height: 48px;
      }
    }
  }
}
.authorize-list{
  dl{
    display: flex;
    margin-bottom:40px;
    &:last-child{
      margin-bottom:0;
    }

    dt{
      width: 300px;
      font-weight: 500;
      i{
        display: inline-block;
        width: 14px;
        height: 14px;
        font-size: 14px;
        margin-right: 10px;
        svg{
           width: 14px;
           height: 14px;
           font-size: 14px;
           vertical-align: middle;
        }
      }
     span{
       vertical-align: middle;
     }
    }
    dd{
      color: #37f;
      cursor: pointer;
    }
  }
}
</style>
<style>
.change-box .el-form-item__label {
  color: #5e6d81;
}
.el-tooltip__popper a {
  color: #37f;
  font-size: 16px;
  line-height: 20px;
}
.el-tooltip__popper {
  font-size: 14px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/Userinfo.vue